import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronDown, ChevronRight } from 'lucide-react'
import './Sidebar.css'

const sidebarData = [
  {
    title: 'Getting Started',
    items: [
      { title: 'Installation', path: '/plugins/VariableModding/getting-started/installation' },
      { title: 'Initial Configuration', path: '/plugins/VariableModding/getting-started/initial-configuration' },
      { title: 'In-Editor Testing', path: '/plugins/VariableModding/getting-started/in-editor-testing' },
      { title: 'In-Game Testing', path: '/plugins/VariableModding/getting-started/in-game-testing' }
    ]
  },
  {
    title: 'Core Concepts',
    items: [
      { title: 'CSV Generation', path: '/plugins/VariableModding/core-concepts/csv-generation' }
    ]
  },
  {
    title: 'Advanced Documentation',
    items: [
      { title: 'Overview', path: '/plugins/VariableModding/advanced' }
    ]
  },
  {
    title: 'Video Tutorials',
    items: [
      { title: 'YouTube: Getting Started', path: '/plugins/VariableModding/video-tutorials/getting-started' },
      { title: 'YouTube: Example in Fragments', path: '/plugins/VariableModding/video-tutorials/example-fragments' }
    ]
  }
]

const SidebarSection = ({ section }) => {
  const [isOpen, setIsOpen] = useState(true)
  const location = useLocation()

  return (
    <div className="sidebar-section">
      <button
        className="sidebar-section-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
        <span className="sidebar-section-title">{section.title}</span>
      </button>
      {isOpen && (
        <div className="sidebar-items">
          {section.items.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className={`sidebar-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

const Sidebar = ({ isOpen, onToggle }) => {
  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-content">
        {sidebarData.map((section, index) => (
          <SidebarSection key={index} section={section} />
        ))}
      </div>
    </aside>
  )
}

export default Sidebar
